import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkModeSubject = new BehaviorSubject<boolean>(false);
  public isDarkMode$: Observable<boolean> = this.isDarkModeSubject.asObservable();

  constructor() {
    this.initTheme();
  }

  private initTheme(): void {
    const savedTheme = localStorage.getItem('theme');
    let isDark = false;
    if (savedTheme) {
      isDark = savedTheme === 'dark';
    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      isDark = true;
    }
    this.setDarkMode(isDark);
  }

  public toggleTheme(): void {
    this.setDarkMode(!this.isDarkModeSubject.value);
  }

  public setDarkMode(isDark: boolean): void {
    this.isDarkModeSubject.next(isDark);

    const applyThemeClasses = () => {
      if (isDark) {
        document.body.classList.add('dark-theme', 'my-app-dark');
        document.documentElement.classList.add('dark-theme', 'my-app-dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.body.classList.remove('dark-theme', 'my-app-dark');
        document.documentElement.classList.remove('dark-theme', 'my-app-dark');
        localStorage.setItem('theme', 'light');
      }
    };

    // Premium 60fps View Transition cross-fade (Modern Browser Standard)
    if (typeof document !== 'undefined' && (document as any).startViewTransition) {
      (document as any).startViewTransition(() => {
        applyThemeClasses();
      });
    } else {
      // Fallback smooth transition for older browsers
      document.body.classList.add('theme-transitioning');
      applyThemeClasses();
      setTimeout(() => {
        document.body.classList.remove('theme-transitioning');
      }, 300);
    }
  }

  public get isDarkMode(): boolean {
    return this.isDarkModeSubject.value;
  }
}
